const giftCardTerms = () => {
  const checkbox = document.querySelector('#gift-card__terms-input')
  const content = document.querySelector('.gift-card__terms-content')

  window.addEventListener('click', function (e) {
    if (!checkbox.checked) return
    const target = e.target
    const itsContent = target === content || content.contains(target) || target === checkbox
    if (!itsContent) checkbox.checked = false
  })
}

export default giftCardTerms
